import I18N from '@leverege/i18n';
import { Config } from '@leverege/plugin';
import System from "../systems/System.js";
import Util from "./Util.js";
const {
  tf
} = I18N.ns('molten.imagine.SystemUserAccess');
export default {
  id: 'molten.SystemUserAccess',
  sort: 100,
  onLoggedIn: async molten => {
    const api = molten.get('api');
    const sysId = api.options.systemId;
    try {
      const sysObj = await api.system(sysId).get();
      const system = new System(sysObj, molten);
      const userManagementOptions = {
        rootUrl: molten.getConfig('personaUrl', '/p/:persona'),
        sort: tf('sort'),
        sectionName: tf('sectionName')
      };
      const apiAccessOptions = {
        rootUrl: molten.getConfig('personaUrl', '/p/:persona'),
        sort: Config.get('SystemApiAccessKeys', 'navSort', Config.get('ApiAccessKeys', 'navSort', 'zzz2')),
        sectionName: Config.get('SystemApiAccessKeys', 'navSectionName', Config.get('ApiAccessKeys', 'navSectionName'))
      };
      Util.createSystemUserAccess(molten, system, userManagementOptions);
      Util.createSystemApiAccess(molten, system, apiAccessOptions);
    } catch (err) {
      console.error(err, 'User does not have access to system users/apiAccess');
    }
  }
};